<template>
  <div class="ibox">
    <div class="ibox-title">
      Criar Novo CustomTable
    </div>

    <div class="ibox-content">
      <div class="form-group">
        <label for="custom-table-name">Nome</label>
        <input v-model="customTable.name" id="custom-table-name" class="form-control">
      </div>

      <div class="form-group">
        <label for="custom-table-email">Descrição</label>
        <input v-model="customTable.description" id="custom-table-email" class="form-control">
      </div>

      <div class="form-group">
        <label for="custom-table-email">Colunas</label>
        <div class="ibox">
          <div class="ibox-content">
            <button class="btn btn-outline" @click="addField()">Adicionar campo</button>

            <div v-if="customTable.columns.length === 0">
              Nenhuma coluna criada
            </div>

            <table v-else>
              <thead>
                <tr>
                  <th>Nome</th>
                  <th>Obrigatório</th>
                  <th>Tipo</th>
                  <th>Valor padrão</th>
                  <th>Exemplo</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(field, index) in customTable.columns" :key="index">
                  <td>{{ field.name }}</td>
                  <td>{{ field.required ? 'Sim' : 'Não' }}</td>
                  <td>{{ field.type }}</td>
                  <td>{{ field.default }}</td>
                  <td :title="field.title">
                    <input v-if="['text', 'number'].includes(field.type)" :type="field.type" class="form-control">

                    <select v-else-if="field.type === 'select'" class="form-control">
                      <option :value="options[1]" v-for="(options, index) in field.options" :key="index">
                        {{ options[0] }}
                      </option>
                    </select>
                  </td>
                  <td>
                    <button @click="move(index, index - 1)" class="btn btn-outline mr-1"
                            :disabled="index === 0">para cima</button>
                    <button @click="move(index, index + 1)" class="btn btn-outline mr-1"
                            :disabled="index + 1 === customTable.columns.length">para baixo</button>

                    <button @click="editField(field)" class="btn btn-outline mr-1">{{ 'btn.edit' | t }}</button>
                    <button @click="removeField(field)" class="btn btn-outline">{{ 'btn.delete' | t }}</button>
                  </td>
                </tr>
              </tbody>
            </table>

          </div>
        </div>
      </div>

      <div class="form-group mt-2">
        <button @click="$router.push('/admin/custom_tables')" class="btn btn-outline btn-lg mr-2">Cancelar</button>
        <button @click="save()" class="btn btn-primary btn-lg mr-2">Aplicar</button>
        <button @click="save(true)" class="btn btn-primary btn-lg mr-2">Salvar</button>
        <button v-if="customTable.id" @click="$router.push(`/admin/custom_tables/${customTable.id}/work`)"
                class="btn btn-outline btn-lg mr-2">Trabalhar</button>
      </div>
    </div>

    <Field v-model="showModal" :field="currentField"/>

  </div>
</template>

<script>
  import ModelMapper from '@/mixins/ModelMapper'
  import Field from '@/components/admin/custom_tables/Field';

  export default {
    components: { Field },
    created() {
      if (!('columns' in this.customTable))
        this.$set(this.customTable, 'columns', [])
    },
    data() {
      return {
        currentField: {},
        modelPathPrefix: 'admin',
        nameModel: 'CustomTable',

        showModal: false
      }
    },
    methods: {
      addField() {
        const field = {}
        this.currentField = field
        this.customTable.columns.push(field)
        this.showModal = true
      },
      editField(field) {
        this.currentField = field
        this.showModal = true
      },
      move(to, from) {
        if (from < 0 || from === this.customTable.columns.length)
          return

        const toRow = this.customTable.columns[to]
        const toFrom = this.customTable.columns[from]
        this.$set(this.customTable.columns, from, toRow)
        this.$set(this.customTable.columns, to, toFrom)
      },
      removeField(field) {
        const index = this.customTable.columns.findIndex(e => e === field)
        this.customTable.columns.splice(index, 1)
      },
      save(close) {
        this.asyncTemplateSave(this.customTable, {
          after: ({model}) => {
            this.$notify.add('CustomTable Salvo com Sucesso!')
            Object.assign(this.customTable, model)
            this.$emit('saveModel', model)

            if (close)
              this.$router.push('/admin/custom_tables')
          },
          before: ({data}) => {
            data.only_columns = true
          }
        })
      },
    },
    mixins: [ModelMapper],
    name: 'Form',
    props: {
      customTable: { required: true, type: Object }
    }
  }
</script>

<style scoped>

</style>